<template>
	<div class="mx-1 my-3">
        <v-subheader style="padding: 0 0 0 10px">
            <v-row dense align="center" class="header-row">
                <v-col cols="3">
                    Navn
                </v-col>
                <v-col cols="9" class="d-flex pa-0 ma-0 justify-space-between">
                    <v-col @click="setSort(field)" class="text-right" v-for="(field, index) in fields" :key="index" :cols="field.cols" :style="equalCols ? equalColsStyle : ''">
                        <v-icon v-if="sort.field === field.field && sort.order">fa-angle-down</v-icon>
                        <v-icon v-else-if="sort.field === field.field">fa-angle-up</v-icon>
                        {{ field.header }}
                    </v-col>
                </v-col>
            </v-row>
        </v-subheader>
        <v-row
            dense
            v-for="(firstKey, mainIndex) in sortedFirstKeys" :key="mainIndex"
            :class="{'odd' : mainIndex % 2 === 0, 'expanded' : expanded[firstKey]}"
            class="main-row"
            @click="expandRow(firstKey)"
            align="center"
        >
            <v-col cols="3" :class="{'bold': expanded[firstKey]}">
                <p :title="firstKey" v-line-clamp="1" class="pl-2 ma-0">
                    {{ firstKey | nameFilter }}
                </p>
            </v-col>
            <v-col cols="9" class="d-flex justify-space-between">
                <v-col
                    v-for="(field, index) in fields" :key="index"
                    :cols="field.cols"
                    class="text-right"
                    :class="{'bold': expanded[firstKey]}"
                    :style="equalCols ? equalColsStyle : ''">
                    {{ field.formatter(subTotals[firstKey][field.field]) }}
                </v-col>
            </v-col>
            <template v-if="expanded[firstKey]">
                <v-col cols="12">
                    <template v-for="(secondKey, subIndex) in sortedSecondKeys(firstKey, Object.keys(dataObject[firstKey]))">
                        <v-divider :key="'c' + subIndex" />
                        <v-row
                            dense
                            align="center"
                            :key="'b' + subIndex"
                            :class="{'odd' : mainIndex % 2 === 0, 'sub-odd' : subIndex % 2 === 0}"
                        >
                            <v-col cols="3">
                                <v-col cols="12">
                                    <p :title="secondKey" v-line-clamp="1" class="ma-0">
                                        {{ secondKey | nameFilter }}
                                    </p>
                                </v-col>
                            </v-col>
                            <v-col cols="9" class="d-flex justify-space-between">
                                <v-col
                                    v-for="(field, index) in fields" :key="index"
                                    :cols="field.cols"
                                    class="text-right"
                                    :style="equalCols ? equalColsStyle : ''">
                                    {{ field.formatter(valueFunctions[field.field] ? valueFunctions[field.field](dataObject[firstKey][secondKey]) : dataObject[firstKey][secondKey][field.field]) }}
                                </v-col>
                            </v-col>
                        </v-row>
                    </template>
                </v-col>
            </template>
        </v-row>
	</div>
</template>

<script>

export default {
    props: {
        dataObject: Object,
        fields: Array,
        nestedFields: Array,
        valueFunctions: Object,
        defaultSort: String,
        equalCols: Boolean
    },
	data () {
		return {
			sort: {
				field: this.defaultSort,
                order: true
			},
            expanded: {}
		};
	},
	computed: {
		sortedFirstKeys() {
			const order = this.sort.order ? -1 : 1;
			return Object.keys(this.dataObject).sort((a, b) => {
				return this.subTotals[a][this.sort.field] >
					this.subTotals[b][this.sort.field]
					? order
					: -order;
			});
        },
        subTotals () {
            let subTotals = {}
            Object.keys(this.dataObject).forEach(key => {
                const nestedFieldTotals = this.$reduceNested(this.dataObject[key], this.nestedFields)
                subTotals[key] = {}
                this.fields.forEach(field => {
                subTotals[key][field.field] = this.valueFunctions[field.field] ? this.valueFunctions[field.field](nestedFieldTotals) : nestedFieldTotals[field.field]
                })
            })
            return subTotals
        },
        equalColsStyle () {
            return `flex-basis: ${100 / this.fields.length}%`
        }
	},
	methods: {
		sortedSecondKeys(firstKey, keys) {
			const order = this.sort.order ? -1 : 1;
			return keys.sort((a, b) => {
                const firstValue = this.valueFunctions[this.sort.field] ? this.valueFunctions[this.sort.field](this.dataObject[firstKey][a]) : this.dataObject[firstKey][a][this.sort.field]
                const secondValue = this.valueFunctions[this.sort.field] ? this.valueFunctions[this.sort.field](this.dataObject[firstKey][b]) : this.dataObject[firstKey][b][this.sort.field]
                return firstValue > secondValue ? order : -order;
			});
		},
		setSort({ field }) {
			if (this.sort.field === field) this.sort.order = !this.sort.order;
			else
				this.sort = {
					field: field,
					order: true
				};
		},
		expandRow(key) {
            if (this.expanded[key] === undefined) {
                this.$set(this.expanded, key, true)
            } else {
                this.expanded[key] = !this.expanded[key]
            }
		}
    }
};
</script>

<style lang="scss" scoped>
    .main-row {
        background: #FFFBFB;
    }
    .odd {
        background: #FFF6E5
    }
    .main-row, .header-row {
        cursor: pointer;

        &:not(:first-child) {
            border: 1px solid #FFF6E5;
        }
    }
    .expanded {
        border: 1px solid black !important;
    }
    .bold {
        font-weight: bold;
    }
</style>